module.exports = __webpack_public_path__ + "img/4diamante.89eaac32.png";